<!--
showBigImg : 是否需要点击查看大图
imgData: 完整图片数据，优先级高于url
url：图片请求地址
width：图片宽度
height：图片高度
-->
<template>
  <span class="utm-imgage-box" :class="boxClass" :id="'imgage_'+ uuid">
    <!-- 如果用户类型没有开启Profile Photo,则Profile Photo字段不显示任何信息 -->
    <template v-if="(isPreview.role=='profilePhotoFileId' && isPreview.isShow===false) || aisPreview"></template>
    <template v-else-if="isPreview.role=='userFaceId' && isPreview.isShow===false"></template>
    <template v-else-if="imgData || imgUrl">
      <img :class="className"
           :src="imgData || imgUrl"
            @click="scaleUrl ? $root.viewBigImg($root.fileBaseUrl + '/Files/Get/' + scaleUrl + '?access_token=' + ApiService.accessToken.substr(7)) : $root.viewBigImg($root.fileBaseUrl + '/Files/Get/' + url + '?access_token=' + ApiService.accessToken.substr(7))"
           :style="{'width':width,'height':height,'object-fit':objectFit}"
           @error="e => { e.target.src = $root.defaultImg}">   
    </template>
    <template v-else>
      <slot>
        <!-- 针对于车辆报表没有绑定司机时不需要展示任何图标 -->
        <span v-if="isHide"></span>
        <!-- 显示车辆的默认照片 -->
        <img v-else-if="className === 'plate-number-img' || boxClass === 'plate-number-box'" class="user-photo" :src="require('../../assets/img/user/default-vehicle.jpg')" :style="{'width':width,'height':height,'object-fit':objectFit}" alt/>
        <img v-else class="user-photo" :src="require('../../assets/img/user/default-user.png')" :style="{'width':width,'height':height,'object-fit':objectFit}" alt/>
      </slot>
    </template>
  </span>
</template>

<script>
    export default {
      name: "utmShowImage",
      props:{
        url:{/*图片的地址，即接口请求地址*/
          type:String,
          default:'',
        },
        imgData:{/*特殊地方使用场景：有的图片不需要调用接口获取，可直接传base64或者本地地址什么的*/
          type:String,
          default:'',
        },
        scaleUrl:{ /*大图显示Url*/
          type:String,
          default:'',
        },
        showBigImg:{/*是否显示大图*/
          type:Boolean,
          default:true,
        },
        width:{/*图片的宽*/
          type:String,
          default:'50px',
        },
        height:{/*图片的高*/
          type:String,
          default:'60px',
        },
        objectFit:{/*图片的显示规则，避免头像被拉升*/
          type:String,
          default:'cover',
        },
        className:{/*自定义图片的属性名*/
          type:String,
          default:'user-photo',
        },
        boxClass:{ /*父级容器class，可以在父组件中修改子组件中的样式，并且不会调用该组件的其他地方*/
          type:String,
          default:'',
        },
        aisPreview:{  /* 主要用于跟人相关的是否开启了Profile Photo的显示功能 */
          type:Boolean,
          default:false,
        },
        isPreview:{
          type:Object,
          default:function(){
           return {
            isShow:false,
            role:''
          }
          }
        },
        isHide:{/* 主要用户车辆的FR Photo的是否是否显示照片，没有绑定系统中的user则不不显示 */
          type:String,
          default:'',
        }
      },
      data(){
        return{
          imgUrl:'',
          base64Url:'',
          uuid:'',
        }
      },
      watch:{
        url:{
          handler(nv,ov){
            if(!this.imgData){
              this.imgUrl = '';
              this.getImgUrl();
            }
          },
          deep:true,
        }
      },
      mounted(){
        this.uuid = this['_uid'];
        if(!this.imgData){
          this.getImgUrl();
        }
      },
      methods:{
        getImgUrl:function(){
          let that = this;
          if(that.url){
            that.imgUrl = that.$root.fileBaseUrl + '/Files/Get/' + that.url + '?access_token=' + that.ApiService.accessToken.substr(7);
          }
        },
        gerTableUrl:function(){
          //特殊处理因为表格中的图片会重复请求所以为了去掉重复的请求，排除浮动时隐藏的元素的图片加载及图片请求
          setTimeout(() => {
            let uid = that['_uid'];
            let dom = document.getElementById('imgage_'+ uid);
            if(that.url && $(dom).parents('.ivu-table-fixed-body').length === 0){
              that.shareApi.getImgUrl(that.url).done(imgUrl =>{
                if(imgUrl){
                  let file = that.dataURLtoFile(imgUrl);
                  that.imgUrl = window.URL.createObjectURL(file);
                  that.$emit('loaded', that.imgUrl);
                }
              })
            }
          },100);
        },
        dataURLtoFile:function(code) {
          code = code.replace(/[\n\r]/g, "");
          let raw = window.atob(code);
          let rawLength = raw.length;
          let uint8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; i++) {
            uint8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uint8Array], { type: "image/jpeg" });
        },
      },
    }
</script>

<style scoped>
  .utm-imgage-box{
    display: inline-block;
    overflow: hidden;
    vertical-align: middle;
  }
  .utm-imgage-box .plate-number-img{
    height: unset;
    width: unset;
    max-width: 100%;
    max-height: 100%;
  }
  .utm-imgage-box .user-photo{
    vertical-align: middle;
  }
  /*列表图片父级显示框*/
  .utm-imgage-box.plate-number-box{
    display: flex;
    justify-content: center;
    max-width: 98px;
    min-width: 50px;
  }
  .photo-radius{
    border-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/utmShowImage.vue